module.exports = __webpack_public_path__ + "img/6dab923c1bb14331a263146fdae93e67-640.534f4581.jpg";